import { MuteText } from '@elements/Common';
import type { ShipmentDynamicFieldType } from '@hooks/shipment';
import { CheckIcon } from '@phosphor-icons/react';
import { DateFormat, DateUtility } from '@utility/date';
import { cn } from '@skupreme/shared/ui';

type TrackingRendererProps = {
  fields: ShipmentDynamicFieldType[];
};

export function TrackingRenderer({ fields }: TrackingRendererProps) {
  return (
    <div className="sk:flex">
      {fields?.map((field, index) => (
        <div
          key={field.name ?? index}
          className={cn(
            'sk:relative sk:flex sk:max-w-25 sk:min-w-25 sk:flex-col sk:items-center',
            'sk:max-[1514px]:max-w-17.5 sk:max-[1514px]:min-w-17.5 sk:max-[1514px]:[&_b]:text-xs sk:max-[1514px]:[&_span]:text-xs',
          )}
        >
          <div
            className={cn(
              'sk:relative sk:size-10 sk:rounded-full sk:border sk:border-solid',
              field.isCompleted
                ? 'sk:border-success sk:bg-success'
                : 'sk:border-border',
            )}
          >
            {field.isCompleted && (
              <CheckIcon
                className="sk:absolute sk:top-1/2 sk:left-1/2 sk:-translate-x-1/2 sk:-translate-y-1/2 sk:text-surface"
                size={25}
              />
            )}
          </div>
          {field.isCompleted ? (
            <b className="sk:mt-3.5!">{field.label}</b>
          ) : (
            <MuteText className="sk:mt-3.5!">
              <b>{field.label}</b>
            </MuteText>
          )}
          {index + 1 !== fields.length && (
            <div
              className={cn(
                'sk:absolute sk:top-5 sk:left-17.5 sk:h-px sk:w-15 sk:max-[1514px]:left-13.75 sk:max-[1514px]:w-7.5',
                fields[index + 1].isCompleted
                  ? 'sk:bg-success'
                  : 'sk:bg-border',
              )}
            />
          )}
          {field.value !== '-' && (
            <>
              <MuteText>
                {DateUtility.formatDate(field.value, DateFormat.date)}
              </MuteText>
              <MuteText>
                {DateUtility.formatDate(field.value, DateFormat.time)}
              </MuteText>
            </>
          )}
        </div>
      ))}
    </div>
  );
}
